import { render } from "./AlgemeneVoorwaarden.vue?vue&type=template&id=8621af3c&ts=true"
import script from "./AlgemeneVoorwaarden.vue?vue&type=script&lang=ts"
export * from "./AlgemeneVoorwaarden.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__